export default "__VITE_ASSET__DheO6B_Y__"